export default {
    apiURL:process.env.VUE_APP_API_URL
}